import React from 'react'
import {Badge, ListGroup} from 'react-bootstrap'
import {FormattedMessage} from 'react-intl'
import {ContactProfileSection, ContactProfileTab} from './contactProfileTypes'

interface ContactSectionsSideProps {
  sections: readonly ContactProfileSection[]
  active: ContactProfileTab
  onSelect: (tab: ContactProfileTab) => void
}

/** Menú lateral de secciones, réplica del `ListSectionSide` de OnePolicyPage. */
export const ContactSectionsSide: React.FC<ContactSectionsSideProps> = ({
  sections,
  active,
  onSelect,
}) => (
  <div className='list-menu'>
    <div className='kt-heading kt-heading--sm custom-border-brand my-3'>
      <FormattedMessage id='contacts.profile.side.sections' defaultMessage='Sections' />
    </div>
    <ListGroup variant='flush'>
      {sections.map((section) => (
        <ListGroup.Item
          key={section.key}
          className='policy-sections d-flex align-items-center'
          action
          variant={active === section.key ? 'primary' : 'light'}
          onClick={() => onSelect(section.key)}
        >
          <i className={`bi bi-${section.icon} fs-3`} style={{color: 'inherit', marginRight: 8}} />
          <span className='flex-grow-1'>{section.label}</span>
          {typeof section.count === 'number' && (
            <Badge bg={active === section.key ? 'light' : 'secondary'} text='dark'>
              {section.count}
            </Badge>
          )}
        </ListGroup.Item>
      ))}
    </ListGroup>
  </div>
)
